/**
 * `{gestor}/api/rest/isa-drive/` (13/10). Sin gestor configurado, la API de
 * siempre (`serviceBaseRest` + `isa-drive/`).
 */
export function baseIsaDriveApi(urls: { serviceBaseGestor?: string; serviceBaseRest?: string } | null | undefined): string {
  const gestor = (urls?.serviceBaseGestor || '').replace(/\/+$/, '');

  return gestor ? `${gestor}/api/rest/isa-drive/` : `${urls?.serviceBaseRest || ''}isa-drive/`;
}
